import { useEffect } from 'react';

export const useIsExpandedRestoreEffect = ({
  isExpandable,
  isExpanded,
  setIsExpanded,
}: {
  isExpandable: boolean;
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
}) => {
  useEffect(() => {
    if (!isExpandable && isExpanded) {
      setIsExpanded(false);
    }
  }, [isExpandable, isExpanded, setIsExpanded]);
};
